// Helpers for the sign-in page. They live outside Login.jsx because component files
// may only export components (react-refresh/only-export-components).

const LAST_USERNAME_KEY = 'pos_last_username';

// The username of the last person who signed in on this device, so the cursor can
// start in Password. Storage can be blocked (private window, locked-down browser);
// then nothing is remembered.
export const readLastUsername = () => {
  try {
    return localStorage.getItem(LAST_USERNAME_KEY) || '';
  } catch {
    return '';
  }
};

export const saveLastUsername = (username) => {
  try {
    localStorage.setItem(LAST_USERNAME_KEY, username);
  } catch {
    // Not remembering the name is harmless.
  }
};

// Turns a failed login() result into what the counter staff need to read:
// what went wrong, and what to do next. `field` marks the boxes to outline in red.
export const describeSignInFailure = ({ status, code, error } = {}) => {
  if (status === 401) {
    return {
      field: 'both',
      title: 'Wrong username or password.',
      hint: 'Check both and try again.',
    };
  }
  if (status === 400 && error === 'Inactive user') {
    return {
      title: 'This account is switched off.',
      hint: 'Ask the admin to switch it on.',
    };
  }
  if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') {
    return {
      title: 'The POS server is taking too long.',
      hint: 'Wait a minute, then try again.',
    };
  }
  if (!status) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return {
        title: 'This device is offline.',
        hint: 'Check the Wi-Fi or cable, then try again.',
      };
    }
    return {
      title: "Can't reach the POS server.",
      hint: 'Check the internet and try again.',
    };
  }
  if (status === 502 || status === 503 || status === 504) {
    return {
      title: 'The POS server is down.',
      hint: 'Try again in a minute. If it stays down, tell the admin.',
    };
  }
  if (status >= 500) {
    return {
      title: 'The POS server hit a problem.',
      hint: 'Try again. If it keeps happening, tell the admin.',
    };
  }
  return {
    title: "Sign-in didn't work.",
    hint: typeof error === 'string' && error !== 'Login failed' ? error : 'Try again.',
  };
};
